import { forwardRef } from 'react'

import { RiSparkling2Fill } from '@remixicon/react'

import { Button, IButtonProps } from './Button'
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip'

export interface IEnhanceAIButtonProps extends IButtonProps {
  children?: React.ReactNode
  shouldShowTooltip?: boolean
  showTokenCount?: boolean
  tokenCount?: number
  tooltipMessage?: string
}

export const EnhanceAIButton = forwardRef<HTMLButtonElement, IEnhanceAIButtonProps>(
  (
    {
      children,
      disabled,
      loading,
      onClick,
      shouldShowTooltip,
      showTokenCount,
      tokenCount,
      tooltipMessage,
      ...props
    },
    ref
  ) => {
    const defaultTooltipMessage = `Enhance selection with AI ${
      showTokenCount ? `– ${tokenCount} free tokens left` : ''
    }`

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            disabled={disabled}
            leftIcon={<RiSparkling2Fill size={14} />}
            loading={loading}
            onClick={onClick}
            ref={ref}
            rightIcon={
              showTokenCount && (
                <span className="text-spectrum-indigo-light rounded-md bg-white/10 px-1.5 py-0.5 text-xs">
                  {tokenCount}
                </span>
              )
            }
            variant="ai"
            {...props}
          >
            {children || 'Enhance with AI'}
          </Button>
        </TooltipTrigger>
        {shouldShowTooltip && (
          <TooltipContent>
            <div className="p-1">{tooltipMessage || defaultTooltipMessage}</div>
          </TooltipContent>
        )}
      </Tooltip>
    )
  }
)
